import styled from '@emotion/styled'
import * as v from '../../../../../variables/styled'

export const SelectItemsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  marginTop: '10px',
  flexWrap: 'wrap',

  '>div':{
    flex:1
  },

  'button.hiddenButton': {
    color: 'transparent',
    background: 'transparent',
  },

  'button.hiddenButton:hover': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:focus': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:active': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  '.MuiCardContent-root': {
    display: 'flex',
    flexDirection: 'row',
  },
  '.tableNoRec':{
    maxWidth:'77vw !important'
  },
  '.tableContainer': {
    display: 'flex',
    flex: 1,
    maxWidth: '60vw',
    flexDirection: 'column',

    '.totalContent': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginTop: '5px',
      padding: '5px',
      fontSize: '1.2rem',

      '.labelText': {
        fontWeight: 'bold',
        marginRight: '15px',
      },
    },

    '.ReactTable': {
      width: '-webkit-fill-available',
      width: '-moz-available',
      width: 'fill-available',
      width: 'stretch',
      width: '100%',
      height: 'fit-content',
    },

    '.ui.table td': {
      padding: '5px',
      borderRight: '1px solid rgba(34,36,38,.1)',
    },

    '.ui.table td:last-child': {
      borderRight: 'none',
    },

    '.ui.table thead th': {
      padding: '8px',
      borderRight: '1px solid rgba(34,36,38,.1)',
    },

    '.ui.table thead th:last-child': {
      borderRight: 'none',
    },
    
    '.tableHeaderTitle': {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },

    'input': {
      padding: '5px 7px !important',
    },
  
    'textarea': {
      padding: '5px 7px !important',
    },

    '.ui.fluid.dropdown': {
      padding: '5px 7px',
      minHeight: '29px',

      'i.dropdown.icon': {
        padding: '5px 7px',
      }
    },

    '.quantity': {
      width: '90px !important',
    },

    '.price': {
      width: '90px !important',
    },

    '.cellActions': {
      width: '85px',
    },

    '.alignLeft': {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-start',
    },

    '.alignRight': {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end'
    },

    '.alignCenter': {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
    },

    'div.actionsContent': {
      display: 'flex',
      paddingTop: '6px',
      height: '100%',
      justifyContent:'center',

      '.MuiIconButton-root': {
        padding: '5px',
      },
    },
  },

  '.recommendItemContainer': {
    marginLeft:'1rem',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,

    '.MuiPaper-elevation1:hover': {
      boxShadow: '0px 1px 3px 2px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
    },

    'span.sectionTitle': {
      fontSize: '1rem',
      fontWeight: 'bold',
    },

    'span.itemTitle': {
      fontSize: '0.9rem',
      fontWeight: 'bold',
    },
  },
})

export const BudgetContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '10px',

  '.MuiCard-root': {
    marginBottom: '10px',
  }, 

  '.MuiCardContent-root': {
    paddingTop: '0px',
    marginBottom: '10px',
  }, 

  '.cardHeaderActions': {
    button: {
      background: 'transparent',
    }
  },

  '.budgetTable': {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',

    'span.tableTitle': {
      fontSize: '1.2rem',
      fontWeight: 'bold',
    }
  },

  '.alignRight': {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  '.alignCenter': {
    display: 'flex',
    justifyContent: 'center',
  }
})